import {
  Backdrop,
  CircularProgress,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  getMerchantUserDetails,
  getCreateMerchantUserOptions,
  MerchantUserActions,
  Log,
} from "../../../services/services";
import FormDialog from "../../FormDialog";

const EditDialogs = ({
  open,
  onClose,
  selectedId,
  setResponse,
  setTableLoaded,
}) => {
  const [optLoaded, setOptLoaded] = useState(false);
  const [options, setOptions] = useState();
  const [loaded, setLoaded] = useState(false);
  const [acc, setAcc] = useState();

  useEffect(() => {
    setLoaded(false);
    setAcc();
    setOptions();
    setOptLoaded(false);
    getMerchantUserDetails(selectedId, setAcc, setLoaded);
    getCreateMerchantUserOptions(setOptions, setOptLoaded);
  }, [selectedId]);

  const handleSubmit = async (values, { setSubmitting }) => {
    Log.info('Click button [Submit] - Update Merchant User details', values)
    await MerchantUserActions({
      pk: selectedId,
      params: {
        ...values,
        business_entities: values.business_entities.map(({ id }) => id) || [],
      },
      action: "update",
    });
    setSubmitting(false);
    onClose();
  };

  return optLoaded && loaded ? (
    <Formik
      initialValues={{
        salutation: acc.salutation ? acc.salutation.id : "",
        first_name: acc.first_name,
        last_name: acc.last_name,
        contact_number: acc.contact_number,
        group: acc?.merchant_group?.id,
        // business_entity: acc.business_entity && acc.business_entity.id,
        department: acc.department && acc.department.id,
        role: acc?.role,
        business_entities: acc?.merchant_user_business_entity || []
      }}
      onSubmit={handleSubmit}
      validationSchema={Yup.object().shape({
        // salutation: Yup.string().required("Salutation is required"),
        first_name: Yup.string().required("First name is required"),
        last_name: Yup.string().required("Last name is required"),
        // contact_number: Yup.string().required("Contact number is required"),
        // group: Yup.string().required("Group is required"),
        // business_entity: Yup.string().required("business_entity is required"),
        // department: Yup.string().required("Department is required"),
      })}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue
        } = props;
        return (
          <FormDialog
            open={open}
            onClose={onClose}
            title="Edit"
            handleSubmit={handleSubmit}
            loading={isSubmitting}
          >
            <Form autoComplete="off" noValidate>
              <Grid
                container
                rowSpacing={2}
                columnSpacing={3}
                sx={{ alignItems: "center", py: 2 }}
              >
                <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    Email
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                    margin="normal"
                    size="small"
                    defaultValue={acc.username}
                    disabled
                    fullWidth
                  />
                </Grid>

                {/* <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    Salutation*
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                    margin="normal"
                    required
                    select
                    id="salutation"
                    name="salutation"
                    size="small"
                    color="secondary"
                    value={values.salutation}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.salutation && errors.salutation)}
                    helperText={touched.salutation && errors.salutation}
                    disabled={isSubmitting}
                    fullWidth
                  >
                    {options.salutation.map((sal) => (
                      <MenuItem key={sal.id} value={sal.id}>
                        {sal.salutation}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}

                <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    First Name*
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="first_name"
                    name="first_name"
                    label="First Name"
                    size="small"
                    color="secondary"
                    value={values.first_name}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.first_name && errors.first_name)}
                    helperText={touched.first_name && errors.first_name}
                    disabled={isSubmitting}
                  />
                </Grid>

                <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    Last Name*
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="last_name"
                    name="last_name"
                    label="Last Name"
                    size="small"
                    color="secondary"
                    value={values.last_name}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.last_name && errors.last_name)}
                    helperText={touched.last_name && errors.last_name}
                    disabled={isSubmitting}
                  />
                </Grid>

                <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    Contact Number
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                    margin="normal"
                    fullWidth
                    id="contact_number"
                    name="contact_number"
                    label="Contact Number"
                    size="small"
                    color="secondary"
                    value={values.contact_number}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(
                      touched.contact_number && errors.contact_number
                    )}
                    helperText={
                      touched.contact_number && errors.contact_number
                    }
                    disabled={isSubmitting}
                  />
                </Grid>

                {/* <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    Department*
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                      margin="normal"
                      required
                      select
                      id="department"
                      name="department"
                      label="Department"
                      size="small"
                      color="secondary"
                      value={values.department}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      error={Boolean(touched.department && errors.department)}
                      helperText={touched.department && errors.department}
                      disabled={isSubmitting}
                      fullWidth
                    >
                      {options.department.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.department}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid> */}

                {/* <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    Group*
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                    margin="normal"
                    required
                    select
                    id="group"
                    name="group"
                    label="Group"
                    size="small"
                    color="secondary"
                    value={values.group}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.group && errors.group)}
                    helperText={touched.group && errors.group}
                    disabled={isSubmitting}
                    fullWidth
                  >
                    {options.group.map((group) => (
                      <MenuItem key={group.id} value={group.id}>
                        {group.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}

                <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                  Business Entities
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <Select
                    id={"business_entities"}
                    name={"business_entities"}
                    getOptionLabel={(option) => option.business_name}
                    getOptionValue={(option) => option.id}
                    closeMenuOnSelect={false}
                    isMulti
                    options={options.business_entity}
                    value={values.business_entities}
                    onChange={(event) => setFieldValue("business_entities", event)}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "40px",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                    menuPortalTarget={document.body}
                  />
                </Grid>
                {/* <Grid item md={2} xs={2}>
                  <Typography variant="subtitle1" sx={{ textAlign: "right" }}>
                    Role*
                  </Typography>
                </Grid>

                <Grid item md={4} xs={4}>
                  <TextField
                    margin="normal"
                    required
                    select
                    id="role"
                    name="role"
                    label="Role"
                    size="small"
                    color="secondary"
                    value={values.role}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onBlur={handleBlur}
                    error={Boolean(touched.role && errors.role)}
                    helperText={touched.role && errors.role}
                    disabled={isSubmitting}
                    fullWidth
                  >
                    {options.role.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid> */}
                <Grid
                  item
                  md={12}
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    my: 2,
                  }}
                ></Grid>
              </Grid>
            </Form>
          </FormDialog>
        );
      }}
    </Formik>
  ) : (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default EditDialogs;
